import { findIndex, pullAt } from "lodash";
import { action, observable, computed, makeObservable } from "mobx";

class BulkSelect {
    @observable isAllSelected = null;
    @observable.shallow selectedPodcastIds = [];
    @observable.shallow selectedStationIds = [];
    @observable.shallow selectedPodcastGroupIds = [];
    @observable.shallow deselectedPodcastIds = [];
    @observable.shallow deselectedStationIds = [];
    @observable.shallow deselectedPodcastGroupIds = [];

    @computed
    get selectedIds() {
        return [...this.selectedPodcastIds, ...this.selectedStationIds, ...this.selectedPodcastGroupIds];
    }

    @computed
    get deselectedIds() {
        return [...this.deselectedPodcastIds, ...this.deselectedStationIds, ...this.deselectedPodcastGroupIds];
    }

    constructor() {
        makeObservable(this);
    }

    @action.bound
    selectAll() {
        this.isAllSelected = true;
        this.selectedPodcastIds = [];
        this.selectedStationIds = [];
        this.selectedPodcastGroupIds = [];
        this.deselectedPodcastIds = [];
        this.deselectedStationIds = [];
        this.deselectedPodcastGroupIds = [];
    }

    @action.bound
    deselectAll() {
        this.isAllSelected = false;
        this.selectedPodcastIds = [];
        this.selectedStationIds = [];
        this.selectedPodcastGroupIds = [];
        this.deselectedPodcastIds = [];
        this.deselectedStationIds = [];
        this.deselectedPodcastGroupIds = [];
    }

    @action.bound
    addSelectedPodcastItem(id) {
        const selectedItemIndex = findIndex(this.selectedPodcastIds, (selectedId) => selectedId === id);
        if (selectedItemIndex === -1) {
            this.selectedPodcastIds.push(id);
            const deselectedItemIndex = findIndex(this.deselectedPodcastIds, (deselectedId) => deselectedId === id);
            if (deselectedItemIndex !== -1) {
                pullAt(this.deselectedPodcastIds, deselectedItemIndex);
            }
        }
    }
    @action.bound
    addSelectedStationItem(id) {
        const selectedItemIndex = findIndex(this.selectedStationIds, (selectedId) => selectedId === id);
        if (selectedItemIndex === -1) {
            this.selectedStationIds.push(id);
            const deselectedItemIndex = findIndex(this.deselectedStationIds, (deselectedId) => deselectedId === id);
            if (deselectedItemIndex !== -1) {
                pullAt(this.deselectedStationIds, deselectedItemIndex);
            }
        }
    }
    @action.bound
    addSelectedPodcastGroupItem(id) {
        const selectedItemIndex = findIndex(this.selectedPodcastGroupIds, (selectedId) => selectedId === id);
        if (selectedItemIndex === -1) {
            this.selectedPodcastGroupIds.push(id);
            const deselectedItemIndex = findIndex(
                this.deselectedPodcastGroupIds,
                (deselectedId) => deselectedId === id
            );
            if (deselectedItemIndex !== -1) {
                pullAt(this.deselectedPodcastGroupIds, deselectedItemIndex);
            }
        }
    }

    @action.bound
    addDeselectedPodcastItem(id) {
        const deselectedItemIndex = findIndex(this.deselectedPodcastIds, (deselectedId) => deselectedId === id);
        if (deselectedItemIndex === -1) {
            this.deselectedPodcastIds.push(id);
            const selectedItemIndex = findIndex(this.selectedPodcastIds, (selectedId) => selectedId === id);
            if (selectedItemIndex !== -1) {
                pullAt(this.selectedPodcastIds, selectedItemIndex);
            }
        }
    }

    @action.bound
    addDeselectedStationItem(id) {
        const deselectedItemIndex = findIndex(this.deselectedStationIds, (deselectedId) => deselectedId === id);
        if (deselectedItemIndex === -1) {
            this.deselectedStationIds.push(id);
            const selectedItemIndex = findIndex(this.selectedStationIds, (selectedId) => selectedId === id);
            if (selectedItemIndex !== -1) {
                pullAt(this.selectedStationIds, selectedItemIndex);
            }
        }
    }

    @action.bound
    addDeselectedPodcastGroupItem(id) {
        const deselectedItemIndex = findIndex(this.deselectedPodcastGroupIds, (deselectedId) => deselectedId === id);
        if (deselectedItemIndex === -1) {
            this.deselectedPodcastGroupIds.push(id);
            const selectedItemIndex = findIndex(this.selectedIds, (selectedId) => selectedId === id);
            if (selectedItemIndex !== -1) {
                pullAt(this.selectedPodcastGroupIds, selectedItemIndex);
            }
        }
    }
}

export default BulkSelect;
